<template>
  <div class="chat-wrapper">
    <div class="chat-msg-body" ref="chatmsglist">
      <div v-for="(item, index) in messageList" :key="index" class="message-item">
        <div v-if="item.activeUserName !== item.sendUserName" style="overflow: auto;width: 100%;">
          <div style="float:right;width: 60%;display: inline-flex;justify-content: right;align-items: flex-start;">
            <div style="margin-right: 2%;font-size: large;">
              <div v-if="item.msgType == 0">
                {{ item.message }}
              </div>
              <div v-else-if="item.msgType == 1">
                <van-image style="width: 100%; height: 100%" :src="item.message" @click="buildImageList(item.message)"></van-image>
              </div>
              <div v-else></div>
              <div style="color: #acacac;font-size: x-small;float: right;">{{ item.msgStatus ? "已读" : "未读" }}</div>
            </div>
            <div>
              <van-image round width="3rem" height="3rem" src="https://img01.yzcdn.cn/vant/cat.jpeg" @click="$refs.iptFile.click()"/>
            </div>
          </div>
        </div>
        <div v-else style="overflow: auto;width: 100%;">
          <div style="float:left;width: 60%;display: inline-flex;justify-content: left;align-items: flex-start;">
            <div style="width: 4.5rem">
              <van-image round width="3rem" height="3rem" src="https://img01.yzcdn.cn/vant/cat.jpeg" @click="$refs.iptFile.click()"/>
            </div>
            <div style="margin-left: 2%;font-size: large;">
              <div v-if="item.msgType == 0">
                {{ item.message }}
              </div>
              <div v-else-if="item.msgType == 1">
                <van-image width="100%" height="100%" :src="item.message" @click="buildImageList(item.message)"></van-image>
              </div>
              <div v-else></div>
              <div style="color: #acacac;font-size: x-small">{{ item.msgStatus ? "已读" : "未读" }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chat-input-bar">
      <van-row :gutter="10">
        <van-col :span="17">
          <van-field type="text" placeholder="发送消息" v-model="msgTextContent" @keyup.enter.native="buildSendTextMsg"></van-field>
        </van-col>
        <van-col :span="7">
          <div class="send_tool">
            <van-button type="primary" @click="buildSendTextMsg" style="width:100%;font-size: 80%;">发送</van-button>
            <van-uploader accept="image/*" :after-read="handleReviewSuccess">
              <van-button type="info" style="width:4.1rem;margin-left: 3%;font-size: 80%;">图片<van-icon name="photo-o"/></van-button>
            </van-uploader>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import {queryMsgList, queryUserMsgList, sendImageToServer} from "../../api/system/sys_personcenter";
import * as Util from "../../lib/utils";
import B2cWebSocket from "../../lib/websocket";
import {ImagePreview} from "vant";
import {backendServer} from "../../api";

export default {
  name: "ChatMessage",
  data() {
    return {
      socketHander: null,
      messageList: [],
      refreshing: false,
      finished: false,
      loading: false,
      receiveUserName:"",
      msgTextContent:"",
      sendUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      reciveUrl: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.receiveUserName = this.$route.params.userName;
    this.socketHander = new B2cWebSocket({url:"ws://"+backendServer.replace("http://", "")+"/imessage/"+Util.getTokenUser()+"/"+this.$route.params.userName});
    this.$emit("titleChange", this.receiveUserName);
    this.socketHander.onmessage(this.onMessage);
    this.getData();
    this.calcMsgBodyHeight();
    window.addEventListener("resize", this.calcMsgBodyHeight);
  },
  beforeDestroy() {
    if (this.socketHander) this.socketHander.close();
    window.removeEventListener("resize", this.calcMsgBodyHeight);
  },
  methods:{
    calcMsgBodyHeight() {
      this.$nextTick(() => {
        const wrapper = this.$el;
        const inputBar = wrapper.querySelector(".chat-input-bar");
        if (!inputBar) return;
        const msgBody = this.$refs.chatmsglist;
        if (!msgBody) return;
        msgBody.style.height = (wrapper.clientHeight - inputBar.offsetHeight) + "px";
      });
    },
    buildImageList(imageUrl){
      ImagePreview({ images: [imageUrl], closeable: true });
    },
    onMessage(res){
      if (res != "b2c_heart" && res != "上线成功！"){
        let msgObject = JSON.parse(res);
        if (msgObject.activeUserName == null){
          msgObject.activeUserName = this.receiveUserName;
        }
        this.messageList.push(msgObject);
        this.$forceUpdate();
        this.$nextTick(()=>{
          this.$refs.chatmsglist.scrollTop= this.$refs.chatmsglist.scrollHeight;
        })
      }
    },
    getData(){
      queryUserMsgList({activeUserName:this.receiveUserName}).then(res=>{
        if (res.success){
          this.messageList.push(...res.data);
          this.$nextTick(() => this.calcMsgBodyHeight());
        }
      });
    },
    onLoad() {
      queryMsgList({userName: null}, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current + 1;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
        this.loading = false;
        this.finished = true;
    });
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    buildSendTextMsg(){
      if (!Util.isStrEmpty(this.msgTextContent)){
        this.socketHander.sendMsg(JSON.stringify({
          receiveUserName:this.receiveUserName,
          sendUserName:Util.getTokenUser(),
          msgType: 0,
          message: this.msgTextContent
        }));
        this.msgTextContent = "";
      }
    },
    handleReviewSuccess(file){
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();
      file.status = 'uploading';
      file.message = "上传中....";
      formData.append('file', uploadFile);
      sendImageToServer(formData).then(res => {
        if (res.success){
          this.socketHander.sendMsg(JSON.stringify({
            receiveUserName:this.receiveUserName,
            sendUserName:Util.getTokenUser(),
            msgType: 1,
            message: res.data
          }));
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.chat-wrapper {
  width: 100%;
  background-color: #cccccc;
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chat-msg-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  margin-top: 1%;
  background-color: #cccccc;
}

.chat-input-bar {
  flex-shrink: 0;
  width: 100%;
  margin: 1% 1%;
  margin-bottom: calc(1% + env(safe-area-inset-bottom, 0px));
}
</style>
